/**
 * NeoClassicalArchetype.js
 * Statistical targets for Neo-Classical music.
 * Inherits from Baroque but adapts for faster Harmonic Rhythm and modern precision.
 */

import { ACTIVE_ARCHETYPE } from './BaseArchetype.js';

export const NEO_CLASSICAL_ARCHETYPE = {
    ...ACTIVE_ARCHETYPE,

    // Harmonic Rhythm: Faster than Baroque.
    // Driving energy requires frequent chord changes (every 2 beats).
    harmonicRhythm: {
        ...ACTIVE_ARCHETYPE.harmonicRhythm,
        target: 0.5, // 0.5 bars per chord (2 chords/bar)
        tolerance: 0.25
    },

    // Voice Distribution: Similar to Baroque but cleaner.
    // Slightly more High-end focus for arpeggios/violins.
    voiceDistribution: {
        ...ACTIVE_ARCHETYPE.voiceDistribution,
        low: 0.30,
        mid: 0.30,
        high: 0.40, // Boosted Highs
        tolerance: 0.15,
        tuttiThreshold: 0.9
    },

    // Dynamic Range: "Motorik". Less terraced, more consistent drive.
    dynamicRange: {
        ...ACTIVE_ARCHETYPE.dynamicRange,
        minVariance: 0.10, // Lower variance allowed (steady state)
        targetVariance: 0.15,
        dynamicShape: 'linear' // Can be linear or flat
    }
};
